import { FC } from 'react'

import imgWarnGrey from '@img/noData.png'

import style from './index.module.less'

export interface INoDataProps {
  tip?: string
}

const NoData: FC<INoDataProps> = (props) => {
  const { tip } = props

  return (
    <div className="flx-center flx-dir-col">
      <div className={style['publish-search-nodata']}>
        <img src={imgWarnGrey} width={35} />
        {tip ? <p>{tip}</p> : null}
      </div>
    </div>
  )
}

export default NoData
